import {
	Contact,
	useDeleteMemberMutation,
	useGetAllMembersOfLazyQuery,
	PageInfo,
} from "@repo/server-api";
import { useState } from "react";

import { DataSource } from "@repo/legacy/components/shared/lists/DataSource";
import { PaginationModel } from "@repo/legacy/components/shared/lists/PaginationModel";

export function useAllMembersDataSource(): DataSource<Contact> {
	const [rows, setRows] = useState<Contact[]>([]);
	const [rowCount, setRowCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [, setPageInfo] = useState<PageInfo | null>(null);
	const [searchBy, setSearchBy] = useState<string>("");
	const [pageModal, setPageModal] = useState<PaginationModel>({
		page: 0,
		pageSize: 10,
	});
	const [contactId, setContactId] = useState<string>("");

	const [deleteMember] = useDeleteMemberMutation({
		onCompleted(data) {
			if (data.deleteMember.boolean) {
				refresh();
			}
		},
	});

	const [getMembers] = useGetAllMembersOfLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data) {
			if (data && data.allMembersOf) {
				setRows(data.allMembersOf?.nodes as Contact[]);
				setRowCount(data.allMembersOf.totalCount);
				setPageInfo(data.allMembersOf.pageInfo);
				setIsLoading(false);
			}
		},
	});

	const refresh = () => {
		fetchDataForContact(pageModal, searchBy, contactId);
	};

	const fetchDataForContact = (page: PaginationModel, searchBy: string, cId: string) => {
		setIsLoading(true);
		setSearchBy(searchBy);
		setPageModal(page);
		if (cId) setContactId(cId);
		if (cId !== "") {
			getMembers({
				variables: {
					contactId: cId,
					first: page.pageSize,
					after: (page.pageSize * page.page).toString(),
				},
			}).then((response) => {
				if (response.data && response.data.allMembersOf) {
					const count = response.data.allMembersOf.nodes?.length;
					if (count === 0 && page.page > 0) {
						// If no data on current page, go back one page
						fetchDataForContact(
							{
								page: page.page - 1,
								pageSize: page.pageSize,
							},
							searchBy,
							cId,
						);
						return;
					}
					setRows(response.data.allMembersOf?.nodes as Contact[]);
					setRowCount(response.data.allMembersOf.totalCount);
					setPageInfo(response.data.allMembersOf.pageInfo);
					setIsLoading(false);
				}
			});
		}
	};

	const deleteDataMember = (id: string, organizationId: string) => {
		deleteMember({
			variables: { memberId: id, organizationId: organizationId },
		});
	};

	return {
		rows,
		rowCount,
		isLoading,
		fetchDataForContact,
		deleteDataMember,
		refresh,
	};
}
